// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Category Studio (A2): tree list with drag & drop. Uses design tokens with fallbacks. */

.CategoryTree-toolbar-cRyJr {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 16px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  margin-bottom: 16px;
}

.CategoryTree-filters-dIR3K {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.CategoryTree-toolbarActions-OHk7P {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
}

.CategoryTree-expandBtn-mSQiF {
  background: none;
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  border-radius: 6px;
  border-radius: var(--radius-1, 6px);
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #181817;
  color: var(--content-text, #181817);
  cursor: pointer;
  white-space: nowrap;
}

.CategoryTree-expandBtn-mSQiF:hover {
  border-color: #d32f2f;
  border-color: var(--primary-bg, #d32f2f);
  color: #d32f2f;
  color: var(--primary-bg, #d32f2f);
}

.CategoryTree-subCount-_KcR1 {
  color: #0e9488;
  font-weight: 700;
}

.CategoryTree-searchInput-xV7y9 {
  min-width: 220px;
}

.CategoryTree-filterSelect-mSEHY {
  min-width: 140px;
}

.CategoryTree-popularToggle-H0JVd {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
  font-size: 14px;
  margin: 0;
  cursor: pointer;
  white-space: nowrap;
}

.CategoryTree-reorderHint-jzAO3 {
  font-size: 13px;
  color: #606060;
  color: var(--content-text-secondary, #606060);
  background: #f4f4f4;
  background: var(--common-disabled-bg, #f4f4f4);
  border-radius: 6px;
  border-radius: var(--radius-1, 6px);
  padding: 6px 12px;
  margin-bottom: 12px;
}

.CategoryTree-empty-TdHje {
  padding: 32px;
  text-align: center;
  color: #606060;
  color: var(--content-text-secondary, #606060);
}

.CategoryTree-tree-B7Esx {
  list-style: none;
  margin: 0;
  padding: 0;
}

.CategoryTree-catItem-xs8Mm {
  margin-bottom: 8px;
}

.CategoryTree-catRow-XBsCt {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: #ffffff;
  background: var(--white-color, #ffffff);
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  border-radius: 12px;
  border-radius: var(--radius-2, 12px);
  -webkit-transition: border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
  transition: border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
  transition: box-shadow 0.15s ease, border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
}

.CategoryTree-catRow-XBsCt:hover {
  border-color: #d32f2f;
  border-color: var(--primary-bg, #d32f2f);
  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.CategoryTree-dragging-cusaP {
  opacity: 0.5;
}

.CategoryTree-handle-iWveD {
  cursor: -webkit-grab;
  cursor: grab;
  color: #9a9a9a;
  color: var(--content-text-secondary, #9a9a9a);
  font-size: 18px;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  line-height: 1;
}

.CategoryTree-caret-CHmyM {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  width: 20px;
  color: #181817;
  color: var(--content-text, #181817);
  padding: 0;
}

.CategoryTree-thumb-awI_i {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  border-radius: var(--radius-1, 6px);
  -o-object-fit: cover;
     object-fit: cover;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

.CategoryTree-thumbPlaceholder-Os1GA {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  border-radius: var(--radius-1, 6px);
  -ms-flex-negative: 0;
      flex-shrink: 0;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  font-weight: 700;
  color: #ffffff;
  text-transform: uppercase;
  background: #d32f2f;
  background: var(--primary-bg, #d32f2f);
}

.CategoryTree-nameCol-wqSn9 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-flex: 1;
      -ms-flex: 1 1;
          flex: 1 1;
  min-width: 120px;
}

.CategoryTree-name-i7aDF {
  font-weight: 600;
  color: #181817;
  color: var(--content-text, #181817);
}

.CategoryTree-meta-Ayrzz {
  font-size: 12px;
  color: #909090;
  color: var(--content-text-secondary, #909090);
}

.CategoryTree-badgePopular-FWiqI {
  font-size: 11px;
  font-weight: 700;
  color: #ffffff;
  background: #0e9488; /* teal accent */
  border-radius: 999px;
  padding: 2px 8px;
}

.CategoryTree-badgeType-aaHI1 {
  font-size: 11px;
  text-transform: capitalize;
  color: #606060;
  color: var(--content-text-secondary, #606060);
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  border-radius: 999px;
  padding: 2px 8px;
}

.CategoryTree-statusSelect-wVlNg,
.CategoryTree-popularSelect-R4DFe {
  min-width: 110px;
}

.CategoryTree-statusActive-QQfmD {
  color: #03a83b;
  font-weight: 600;
}

.CategoryTree-statusInactive-q4gw3 {
  color: #ff4c4c;
  font-weight: 600;
}

.CategoryTree-actions-LE4Zx {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
}

.CategoryTree-actionLink-WRars,
.CategoryTree-actionBtn-k3KzF {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border-radius: var(--radius-1, 6px);
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  background: #ffffff;
  background: var(--white-color, #ffffff);
  cursor: pointer;
  color: #181817;
  color: var(--content-text, #181817);
  font-size: 16px;
  text-decoration: none;
}

.CategoryTree-actionLink-WRars:hover,
.CategoryTree-actionBtn-k3KzF:hover {
  border-color: #d32f2f;
  border-color: var(--primary-bg, #d32f2f);
  color: #d32f2f;
  color: var(--primary-bg, #d32f2f);
}

.CategoryTree-icon-xC1KT {
  width: 16px;
  height: 16px;
}

.CategoryTree-subTree-CVpsJ {
  list-style: none;
  margin: 4px 0 0 0;
  padding: 0 0 0 48px;
}

.CategoryTree-subRow-TVhY1 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
  padding: 7px 12px;
  margin-top: 4px;
  background: #f9f9f9;
  background: var(--common-light-bg, #f9f9f9);
  border: 1px dashed #e4e4e4;
  border: 1px dashed var(--border-color, #e4e4e4);
  border-radius: 6px;
  border-radius: var(--radius-1, 6px);
}

.CategoryTree-subName-D6COQ {
  -webkit-box-flex: 1;
      -ms-flex: 1 1;
          flex: 1 1;
  color: #181817;
  color: var(--content-text, #181817);
}

.CategoryTree-subStatus-ezmv1 {
  font-size: 12px;
  text-transform: capitalize;
}

.CategoryTree-subInput-LqGXl {
  -webkit-box-flex: 1;
      -ms-flex: 1 1;
          flex: 1 1;
  min-width: 0;
  height: 34px;
  margin: 0;
}

.CategoryTree-subStatusSelect-SCBvM {
  min-width: 110px;
  height: 34px;
}

.CategoryTree-subAddRow-zm0zK {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
  padding: 7px 12px;
  margin-top: 6px;
  border-radius: 6px;
  border-radius: var(--radius-1, 6px);
  background: transparent;
  border: 1px dashed #d6d6d6;
  border: 1px dashed var(--border-color, #d6d6d6);
}

.CategoryTree-subAddBtn-NUxHI {
  height: 34px;
  padding: 0 16px;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/Category/CategoryTree/CategoryTree.css"],"names":[],"mappings":"AAAA,yFAAyF;;AAEzF;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAA8C;EAA9C,8CAA8C;EAC9C,kBAAmC;EAAnC,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAmC;EAAnC,mCAAmC;EACnC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAwC;EAAxC,wCAAwC;EACxC,cAAiC;EAAjC,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAA6C;EAA7C,6CAA6C;EAC7C,mBAA8C;EAA9C,8CAA8C;EAC9C,kBAAmC;EAAnC,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAA6C;EAA7C,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAuC;EAAvC,uCAAuC;EACvC,yBAA8C;EAA9C,8CAA8C;EAC9C,mBAAoC;EAApC,oCAAoC;EACpC,0EAA0D;EAA1D,kEAA0D;EAA1D,0DAA0D;EAA1D,yFAA0D;AAC5D;;AAEA;EACE,qBAAwC;EAAxC,wCAAwC;EACxC,iDAAyC;UAAzC,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAY;EAAZ,YAAY;EACZ,cAA6C;EAA7C,6CAA6C;EAC7C,eAAe;EACf,yBAAiB;KAAjB,sBAAiB;MAAjB,qBAAiB;UAAjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAmC;EAAnC,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAmC;EAAnC,mCAAmC;EACnC,oBAAiB;KAAjB,iBAAiB;EACjB,oBAAc;MAAd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAmC;EAAnC,mCAAmC;EACnC,oBAAc;MAAd,cAAc;EACd,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,mBAAO;MAAP,aAAO;UAAP,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAmC;EAAnC,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,cAA6C;EAA7C,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB,EAAE,gBAAgB;EACrC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,cAA6C;EAA7C,6CAA6C;EAC7C,yBAA8C;EAA9C,8CAA8C;EAC9C,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAmC;EAAnC,mCAAmC;EACnC,yBAA8C;EAA9C,8CAA8C;EAC9C,mBAAuC;EAAvC,uCAAuC;EACvC,eAAe;EACf,cAAmC;EAAnC,mCAAmC;EACnC,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,qBAAwC;EAAxC,wCAAwC;EACxC,cAAiC;EAAjC,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,mBAA2C;EAA3C,2CAA2C;EAC3C,0BAA+C;EAA/C,+CAA+C;EAC/C,kBAAmC;EAAnC,mCAAmC;AACrC;;AAEA;EACE,mBAAO;MAAP,aAAO;UAAP,SAAO;EACP,cAAmC;EAAnC,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAO;MAAP,aAAO;UAAP,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,kBAAmC;EAAnC,mCAAmC;EACnC,uBAAuB;EACvB,0BAA+C;EAA/C,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB","sourcesContent":["/* Category Studio (A2): tree list with drag & drop. Uses design tokens with fallbacks. */\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.filters {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.toolbarActions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.expandBtn {\n  background: none;\n  border: 1px solid var(--border-color, #e4e4e4);\n  border-radius: var(--radius-1, 6px);\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--content-text, #181817);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.expandBtn:hover {\n  border-color: var(--primary-bg, #d32f2f);\n  color: var(--primary-bg, #d32f2f);\n}\n\n.subCount {\n  color: #0e9488;\n  font-weight: 700;\n}\n\n.searchInput {\n  min-width: 220px;\n}\n\n.filterSelect {\n  min-width: 140px;\n}\n\n.popularToggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  margin: 0;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.reorderHint {\n  font-size: 13px;\n  color: var(--content-text-secondary, #606060);\n  background: var(--common-disabled-bg, #f4f4f4);\n  border-radius: var(--radius-1, 6px);\n  padding: 6px 12px;\n  margin-bottom: 12px;\n}\n\n.empty {\n  padding: 32px;\n  text-align: center;\n  color: var(--content-text-secondary, #606060);\n}\n\n.tree {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.catItem {\n  margin-bottom: 8px;\n}\n\n.catRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  background: var(--white-color, #ffffff);\n  border: 1px solid var(--border-color, #e4e4e4);\n  border-radius: var(--radius-2, 12px);\n  transition: box-shadow 0.15s ease, border-color 0.15s ease;\n}\n\n.catRow:hover {\n  border-color: var(--primary-bg, #d32f2f);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.dragging {\n  opacity: 0.5;\n}\n\n.handle {\n  cursor: grab;\n  color: var(--content-text-secondary, #9a9a9a);\n  font-size: 18px;\n  user-select: none;\n  line-height: 1;\n}\n\n.caret {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  width: 20px;\n  color: var(--content-text, #181817);\n  padding: 0;\n}\n\n.thumb {\n  width: 36px;\n  height: 36px;\n  border-radius: var(--radius-1, 6px);\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.thumbPlaceholder {\n  width: 36px;\n  height: 36px;\n  border-radius: var(--radius-1, 6px);\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  color: #ffffff;\n  text-transform: uppercase;\n  background: var(--primary-bg, #d32f2f);\n}\n\n.nameCol {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 120px;\n}\n\n.name {\n  font-weight: 600;\n  color: var(--content-text, #181817);\n}\n\n.meta {\n  font-size: 12px;\n  color: var(--content-text-secondary, #909090);\n}\n\n.badgePopular {\n  font-size: 11px;\n  font-weight: 700;\n  color: #ffffff;\n  background: #0e9488; /* teal accent */\n  border-radius: 999px;\n  padding: 2px 8px;\n}\n\n.badgeType {\n  font-size: 11px;\n  text-transform: capitalize;\n  color: var(--content-text-secondary, #606060);\n  border: 1px solid var(--border-color, #e4e4e4);\n  border-radius: 999px;\n  padding: 2px 8px;\n}\n\n.statusSelect,\n.popularSelect {\n  min-width: 110px;\n}\n\n.statusActive {\n  color: #03a83b;\n  font-weight: 600;\n}\n\n.statusInactive {\n  color: #ff4c4c;\n  font-weight: 600;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.actionLink,\n.actionBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-1, 6px);\n  border: 1px solid var(--border-color, #e4e4e4);\n  background: var(--white-color, #ffffff);\n  cursor: pointer;\n  color: var(--content-text, #181817);\n  font-size: 16px;\n  text-decoration: none;\n}\n\n.actionLink:hover,\n.actionBtn:hover {\n  border-color: var(--primary-bg, #d32f2f);\n  color: var(--primary-bg, #d32f2f);\n}\n\n.icon {\n  width: 16px;\n  height: 16px;\n}\n\n.subTree {\n  list-style: none;\n  margin: 4px 0 0 0;\n  padding: 0 0 0 48px;\n}\n\n.subRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 12px;\n  margin-top: 4px;\n  background: var(--common-light-bg, #f9f9f9);\n  border: 1px dashed var(--border-color, #e4e4e4);\n  border-radius: var(--radius-1, 6px);\n}\n\n.subName {\n  flex: 1;\n  color: var(--content-text, #181817);\n}\n\n.subStatus {\n  font-size: 12px;\n  text-transform: capitalize;\n}\n\n.subInput {\n  flex: 1;\n  min-width: 0;\n  height: 34px;\n  margin: 0;\n}\n\n.subStatusSelect {\n  min-width: 110px;\n  height: 34px;\n}\n\n.subAddRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 12px;\n  margin-top: 6px;\n  border-radius: var(--radius-1, 6px);\n  background: transparent;\n  border: 1px dashed var(--border-color, #d6d6d6);\n}\n\n.subAddBtn {\n  height: 34px;\n  padding: 0 16px;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toolbar": `CategoryTree-toolbar-cRyJr`,
	"filters": `CategoryTree-filters-dIR3K`,
	"toolbarActions": `CategoryTree-toolbarActions-OHk7P`,
	"expandBtn": `CategoryTree-expandBtn-mSQiF`,
	"subCount": `CategoryTree-subCount-_KcR1`,
	"searchInput": `CategoryTree-searchInput-xV7y9`,
	"filterSelect": `CategoryTree-filterSelect-mSEHY`,
	"popularToggle": `CategoryTree-popularToggle-H0JVd`,
	"reorderHint": `CategoryTree-reorderHint-jzAO3`,
	"empty": `CategoryTree-empty-TdHje`,
	"tree": `CategoryTree-tree-B7Esx`,
	"catItem": `CategoryTree-catItem-xs8Mm`,
	"catRow": `CategoryTree-catRow-XBsCt`,
	"dragging": `CategoryTree-dragging-cusaP`,
	"handle": `CategoryTree-handle-iWveD`,
	"caret": `CategoryTree-caret-CHmyM`,
	"thumb": `CategoryTree-thumb-awI_i`,
	"thumbPlaceholder": `CategoryTree-thumbPlaceholder-Os1GA`,
	"nameCol": `CategoryTree-nameCol-wqSn9`,
	"name": `CategoryTree-name-i7aDF`,
	"meta": `CategoryTree-meta-Ayrzz`,
	"badgePopular": `CategoryTree-badgePopular-FWiqI`,
	"badgeType": `CategoryTree-badgeType-aaHI1`,
	"statusSelect": `CategoryTree-statusSelect-wVlNg`,
	"popularSelect": `CategoryTree-popularSelect-R4DFe`,
	"statusActive": `CategoryTree-statusActive-QQfmD`,
	"statusInactive": `CategoryTree-statusInactive-q4gw3`,
	"actions": `CategoryTree-actions-LE4Zx`,
	"actionLink": `CategoryTree-actionLink-WRars`,
	"actionBtn": `CategoryTree-actionBtn-k3KzF`,
	"icon": `CategoryTree-icon-xC1KT`,
	"subTree": `CategoryTree-subTree-CVpsJ`,
	"subRow": `CategoryTree-subRow-TVhY1`,
	"subName": `CategoryTree-subName-D6COQ`,
	"subStatus": `CategoryTree-subStatus-ezmv1`,
	"subInput": `CategoryTree-subInput-LqGXl`,
	"subStatusSelect": `CategoryTree-subStatusSelect-SCBvM`,
	"subAddRow": `CategoryTree-subAddRow-zm0zK`,
	"subAddBtn": `CategoryTree-subAddBtn-NUxHI`
};
module.exports = ___CSS_LOADER_EXPORT___;
